import classnames from 'classnames';
import { IconProps } from '../types';

/**
 * Stripe's Link mark: the black chevron on Link green, as Stripe's Dashboard shows a Link payment.
 */
export default function LinkIcon(props: IconProps) {
  const { className, style } = props;

  return (
    <svg className={classnames('h-5', className)} viewBox="0 0 24 24" style={style} role="img" aria-label="Link">
      <rect width="24" height="24" rx="5" fill="#00D66F" />
      <path d="M9 6h4.2l5 6-5 6H9l5-6z" fill="#011E0F" />
    </svg>
  );
}
